module.exports = __webpack_public_path__ + "img/product-21.60413a19.jpg";